module.exports = __webpack_public_path__ + "static/media/no-documents.a84abc58.svg";